export const URLS = {
  //BACKEND: 'http://localhost:3011' 
  //BACKEND: 'http://10.211.55.3:3011'
  //BACKEND: 'https://dev.productselector.de'
  BACKEND: 'https://productselector.de'
};





// WEBPACK FOOTER //
// ./src/urls.js